import wordlist from '../configs/WordList';

const generator = () => {
    const dateTime = new Date();
    const date = new Date(dateTime.getTime());
    date.setHours(0, 0, 0, 0);
    return date.getTime()/1000000;
}

const FINDING_WORD = wordlist[generator() % wordlist.length];

export default FINDING_WORD;
